const $$splitComponentImporter = () => import('/home/runner/work/upple-client-v2/upple-client-v2/src/routes/public/coaching-notes/$coachingNoteId.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import type { SupportedLanguage } from '@/i18n';
import { createFileRoute } from '@tanstack/react-router';
export const Route = createFileRoute('/public/coaching-notes/$coachingNoteId')({
  validateSearch: search => {
    return {
      redirectToken: search.redirectToken as string ?? '',
      lang: search.lang as SupportedLanguage ?? 'ko'
    };
  },
  component: lazyRouteComponent($$splitComponentImporter, 'component', () => Route.ssr)
});
export function TSRDummyComponent() {
  return null;
}